import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "./store";
import { getOrgId } from "./orgHelpers";
import { WalletService } from "../services/WalletService";
import { ProfitService } from "../services/ProfitService";
import { CreateWallet, WalletAddCredit, WalletAddCreditPayload } from "../models/Wallet";
import { fetchClientsByOrganization, setHardWallets } from "./UserSlice";

interface WalletState {
    hwModalStatus: boolean
    creatingLoader: boolean,
    addCreditStatus: boolean,
    organizationWallets: Array<any> | null
}

const initialState: WalletState = {
    hwModalStatus: false,
    creatingLoader: false,
    addCreditStatus: false,
    organizationWallets: []
};

const walletSlice = createSlice({
    name: 'wallet',
    initialState,
    reducers: {
        setHwModalStatus: (state, action : PayloadAction<boolean> ) => {
            state.hwModalStatus = action.payload;
        },
        setCreatingLoader: (state, action : PayloadAction<boolean> ) => {
            state.creatingLoader = action.payload;
        },
        setAddCreditStatus: (state, action : PayloadAction<boolean> ) => {
            state.addCreditStatus = action.payload;
        },
        setOrganizationWallets: (state, action : PayloadAction<Array<any>> ) => {
            state.organizationWallets = action.payload;
        },
    }
});

export const {
    setHwModalStatus,
    setCreatingLoader,
    setOrganizationWallets,
    setAddCreditStatus
} = walletSlice.actions;

export const createWallet = (form:CreateWallet): AppThunk<Promise<void>> => async (dispatch, getState) => {
    const state = getState();
    try {
        if (!form) throw new Error('Sem dados pra criar a carteira')
        const createWalletResponse : any = await WalletService.createWallet(form,state.user.userInfo.id);
        if (!createWalletResponse) throw new Error('Erro ao tentar criar carteira')
        dispatch(setHardWallets(createWalletResponse.list));
        dispatch(setCreatingLoader(false));
        dispatch(setHwModalStatus(false));
    } catch (e) {
        console.error(e);
        dispatch(setCreatingLoader(false));
    }
}

export const fetchHardWalletsByUserId = () : AppThunk<Promise<void>> => async (dispatch, getState) => {
    const state = getState();
    const getHwresponse : any = await WalletService.getHwByUserId(state.user.userInfo.id);
    if (!getHwresponse)throw new Error('Erro ao pegar as carteiras')
    dispatch(setHardWallets(getHwresponse));

}

export const fetchWalletsByOrganizations = (): AppThunk<Promise<void>> => async (dispatch, getState) => {
    const state = getState();
    const orgWallets : any = await WalletService.getOrgWallets(getOrgId(state));
    if (!orgWallets)throw new Error('Erro ao pegar as carteiras da organizacao')
    dispatch(setOrganizationWallets(orgWallets));

}

export default walletSlice.reducer;

/*
    Acoes da carteira lucro
*/
export const withdrawFromProfit = (value: number): AppThunk<Promise<boolean>> => async (dispatch, getState) => {
    const state = getState();
    try {
        const resp: any = await ProfitService.withdraw({
            organization_id: getOrgId(state),
            value,
        });
        if (!resp) throw new Error("Erro ao sacar da carteira de lucro");
        dispatch(fetchWalletsByOrganizations());
        return true;
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const transferProfitToCompany = (value: number): AppThunk<Promise<boolean>> => async (dispatch, getState) => {
    const state = getState();
    try {
        const resp: any = await ProfitService.transferToCompany({
            organization_id: getOrgId(state),
            value,
        });
        if (!resp) throw new Error("Erro ao transferir da carteira de lucro para a empresa");
        dispatch(fetchWalletsByOrganizations());
        return true;
    } catch (e) {
        console.error(e);
        return false;
    }
}

// credit
// Retorna true/false para o chamador (modal) fechar e disparar o toast.
export const addCreditForWallet = (payload: WalletAddCreditPayload): AppThunk<Promise<boolean>> => async (dispatch, getState) => {
    const state = getState();
    try {
        const orgWallets : any = await WalletService.addCredit(payload);
        if (!orgWallets)throw new Error('Erro ao adicionar credito a carteira');
        dispatch(setAddCreditStatus(true));
        dispatch(fetchClientsByOrganization())
        return true;
    } catch (e) {
        console.error(e);
        return false;
    } finally {

    }

}